/** these are ids from database */
export enum DeliveryMethodEnum {
  check = 1,
  ach = 2,
  wireTransfer = 3,
  leaveInCash = 4,
  journalCash = 5,
  moveToRetail = 6,
}